import { forwardRef } from 'react';

import { DataTestId } from '../../core/types/data-props.js';
import { DOMProps } from '../../core/types/dom.js';
import { StylingProps } from '../../core/types/styling-props.js';
import { WithChildren } from '../../core/types/with-children.js';
import { Flex } from '../../layouts/flex/Flex.js';

//#region Typings
/**
 * @public
 */
export interface InformationOverlayIconProps
  extends DOMProps, WithChildren, DataTestId, StylingProps {}
//#endregion Typings

/**
 * The content of the InformationOverlay.
 * @public
 */
export const InformationOverlayIcon = forwardRef<
  HTMLDivElement,
  InformationOverlayIconProps
>((props, forwardedRef) => {
  const {
    children,
    className,
    style,
    'data-testid': dataTestId,
    ...remainingProps
  }: InformationOverlayIconProps = props;

  return (
    <Flex
      data-testid={dataTestId}
      ref={forwardedRef}
      className={className}
      style={style}
      {...remainingProps}
    >
      {children}
    </Flex>
  );
});

(
  InformationOverlayIcon as typeof InformationOverlayIcon & {
    displayName: string;
  }
).displayName = 'InformationOverlay.Icon';
